import Vue from 'vue'
import Vuex from 'vuex'
import assetClass from './modules/assetClass'
import permissions from './modules/permissions'
import productDetails from './modules/ProductDetails/productDetails'
import search from './modules/Search/search'
import scoringProfilesFilters from './modules/ScoringProfiles/scoringProfilesFilters'
import scoringProfileEditor from './modules/ScoringProfiles/scoringProfileEditor'
import timeHorizonIntervals from './modules/timeHorizonIntervals'
import scoringProfilesList from './modules/ScoringProfiles/scoringProfilesList'
import scoringProfilesCommon from './modules/ScoringProfiles/scoringProfilesCommon'
import scoringProfilesDetails from './modules/ScoringProfiles/scoringProfilesDetails'
import scoringProfilesCoverageDetail from './modules/ScoringProfiles/scoringProfilesCoverageDetail'
import scoringProfilesDefinition from './modules/ScoringProfiles/scoringProfilesDefinition'
import scoringProfilesModelsList from './modules/ScoringProfiles/scoringProfilesModelsList'
import scoringProfilesModelsEditing from './modules/ScoringProfiles/scoringProfilesModelsEditing'
import monitoringList from './modules/ScoringProfiles/monitoringList'
import efficiencyTestsList from './modules/EfficiencyTests/efficiencyTestsList'
import efficiencyTestsCommon from './modules/EfficiencyTests/efficiencyTestsCommon'
import efficiencyTestsEditor from './modules/EfficiencyTests/efficiencyTestsEditor'
import efficiencyTestsFilters from './modules/EfficiencyTests/efficiencyTestsFilters'
import efficiencyTestsDetails from './modules/EfficiencyTests/efficiencyTestsDetails'
import efficiencyTestsCoverageDetail from './modules/EfficiencyTests/efficiencyTestsCoverageDetail'
import efficiencyTestsDefinition from './modules/EfficiencyTests/efficiencyTestsDefinition'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    assetClass,
    permissions,
    productDetails,
    search,
    scoringProfilesFilters,
    scoringProfileEditor,
    timeHorizonIntervals,
    scoringProfilesList,
    scoringProfilesCommon,
    scoringProfilesDetails,
    scoringProfilesDefinition,
    scoringProfilesCoverageDetail,
    scoringProfilesModelsList,
    scoringProfilesModelsEditing,
    monitoringList,
    efficiencyTestsList,
    efficiencyTestsCommon,
    efficiencyTestsEditor,
    efficiencyTestsDetails,
    efficiencyTestsFilters,
    efficiencyTestsDefinition,
    efficiencyTestsCoverageDetail,
  },

  //Left empty due modularization
  state: {},
  mutations: {},
  actions: {},
  getters: {},
})
